import { connect } from 'react-redux';
import View from './error.presenter';

// Map & Connect
export const mapStateToProps = state => ({
  errorScenarios: state.authorableContentReducer.authorableContent.errorScenarios,
  errorSection: state.authorableContentReducer.authorableContent.errorSection,
});

const ErrorPage = connect(
  mapStateToProps,
)(View);

export default ErrorPage;
